<template>
  <el-drawer
    :visible.sync="drawer"
    direction="rtl"
    :with-header="false"
    size="80%"
    :wrapperClosable="false"
  >
    <div class="DrowJianyan" v-if="drawer">
      <el-container>
        <el-header class="el_headersd">
          <fw-header :titles="headers.title" />
        </el-header>

        <el-main class="mainsd">
          <vxe-table
            max-height="100%"
            class="mytable-scrollbar"
            stripe
            highlight-hover-row
            size="small"
            :border="false"
            ref="xTable1"
            :data="tableList"
            auto-resize
          >
            <vxe-column type="seq" title="序号" width="50" align="center"></vxe-column>

            <vxe-column>
              <template #header>
                <p>下载时间</p>
              </template>
              <template #default="{ row }">
                <p>{{ row.created_at }}</p>
              </template>
            </vxe-column>
            <vxe-column>
              <template #header>
                <p>下载状态</p>
              </template>
              <template #default="{ row }">
                <p>
                  <span v-if="row.status == 0">文件生成中</span>
                  <span v-if="row.status == 1">已完成</span>
                  <span v-if="row.status == 2">生成失败</span>
                </p>
              </template>
            </vxe-column>

            <vxe-column>
              <template #header>
                <p>操作</p>
              </template>
              <template #default="{ row }">
                <div>
                  <el-link @click="dowlonad(row)" class="links" :underline="false" type="primary">
                    下载到本地
                  </el-link>
                </div>
              </template>
            </vxe-column>
          </vxe-table>
        </el-main>

        <el-footer height="auto">
          <fw-pageNumber align="right" :pages="pages" @changePage="changePage" />
          <el-row style="margin-top: 20px; padding-bottom: 20px">
            <el-col :span="24" align="center">
              <el-button @click="drawer = false" style="width: 100px" size="small">取消</el-button>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "DrowJianyan",
  components: {},
  data() {
    return {
      drawer: false,
      saveBack: null,
      headers: {
        title: "下载记录",
      },
      tableList: [],
      pages: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    async dowlonad(row) {
      const url = row.path;

      const link = document.createElement("a");
      link.href = url;
      link.download = "素材下载文件.zip"; // 自定义下载文件名
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    changePage(val) {
      if (val.type == "size") {
        this.pages.pageSize = val.num;
      } else {
        this.pages.pageNum = val.num;
      }
      this.query();
    },
    open(val) {
      console.log(val);
      this.drawer = true;
      this.query();
    },
    query() {
      this.$axios.get("/sucai_manage/user/download_list").then(res => {
        if (res.code == 200) {
          this.tableList = res.data.data;
          this.pages.total = res.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.DrowJianyan {
  height: 100vh;
  padding: 0 15px;
  .mainsd {
    padding: 20px 0 !important;
  }
  .links {
    margin: 0 5px;
  }
}
</style>
